module.exports = __webpack_public_path__ + "static/media/kids_57.5b0091f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_57.jpg
// module id = 5913
// module chunks = 0